import { createFileRoute } from '@tanstack/react-router';
import { JourneysFormsDetailsHandoff } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type_/$formId',
)({
  component: JourneysFormDetailsHandoffRoute,
});

function JourneysFormDetailsHandoffRoute() {
  const { workspaceId, type, formId } = Route.useParams();
  return <JourneysFormsDetailsHandoff workspaceId={String(workspaceId)} type={type} formId={formId} />;
}
